module.exports = __webpack_public_path__ + "3.png?fbf4b719bcb46b568956f72c480fd944";